import { IconLoader } from 'common/IconLoader';
import { getDeviceSwVersion, distillProductType, checkStringForHTML } from 'common/utils/helpers';
import { connect, useDispatch, useSelector } from 'react-redux';
import SvgAF, { IconAndText } from 'components/shared/SvgAF/SvgAF';
import Modal from 'components/shared/Modal/Modal';
import React, { Component, useState, memo, useRef, useEffect } from 'react';
import classnames from 'classnames';
import { getSingleDevice, doGetBundle, doCreateBundle, doPatchBundle } from 'redux/actions';
import './PreCommissionStepper.css';
import { getDevice } from 'apis/GetDevice';

const PreCommissionStepperUnitCell = (props) => {
  const UNITCELL_MODES = {
    PRELOADED: 'PRELOADED',
    INITIALIZED: 'INITIALIZED',
    PENDING: 'PENDING',
    ERROR: 'ERROR',
    COMPLETED: 'COMPLETED',
    TRANSITIONED: 'TRANSITIONED',
    DISABLED: 'DISABLED'
  };

  const dispatch = useDispatch();

  const [inputValue, setInputValue] = useState('');
  const [readyCells, setReadyCells] = useState([false, false, false]);
  const [errorMessage, setErrorMessage] = useState(null);
  const [cellMode, setCellMode] = useState(UNITCELL_MODES.INITIALIZED);
  const [deviceId, setDeviceId] = useState(null);
  const [swVersion, setSwVersion] = useState(null);

  const [isRemoveDeviceModalOpen, setRemoveDeviceModalOpen] = useState(false);

  useEffect(() => {
    if (props.readOnly === true) setCellMode(UNITCELL_MODES.TRANSITIONED);
    if (props.readOnly === false) setCellMode(UNITCELL_MODES.PRELOADED);
  }, [props.readOnly]);

  useEffect(() => {
    if (cellMode === UNITCELL_MODES.ERROR) {
      props.sendValues && props.sendValues({ isReady: false });
    }
  }, [cellMode]);

  useEffect(() => {
    setDeviceId(props.deviceId);

    if (props.type === 'donor') {
      setCellMode(UNITCELL_MODES.TRANSITIONED);
      props.sendValues && props.sendValues({ isReady: true });
    }

    setSwVersion(props.swVersion);
  }, [props.deviceId]);

  useEffect(() => {
    if (inputValue != null && inputValue != '') props.sendValues && props.sendValues({ isReady: false });
  }, [inputValue]);

  if (cellMode === UNITCELL_MODES.COMPLETED) {
    setTimeout(() => {
      setCellMode(UNITCELL_MODES.TRANSITIONED);
      props.sendValues && props.sendValues({ isReady: true });
    }, 1500);
  }

  let removeDeviceModal = null;

  if (isRemoveDeviceModalOpen) {
    removeDeviceModal = (
      <Modal
        closeTargetRef={null}
        close={() => {
          setRemoveDeviceModalOpen(false);
        }}
        animate={false}
        animateX={false}
        opaque={true}
        height={256}
        width={464}
      >
        <div className="removeDeviceModal">
          <div className="removeDeviceModalTitle">Unit will be removed from the site</div>
          <div className="removeDeviceModalButtonRow">
            <button
              className="removeDeviceModalButtonRowCancel Global_CancelButton"
              onClick={() => {
                setRemoveDeviceModalOpen(false);
              }}
            >
              Cancel
            </button>
            <button
              className="removeDeviceModalButtonRowOkay Global_ApplyButton"
              onClick={() => {
                setRemoveDeviceModalOpen(false);
                props.sendValues({ doReset: true });
                setCellMode(UNITCELL_MODES.INITIALIZED);
                setInputValue('');
              }}
            >
              Confirm
            </button>
          </div>
        </div>
      </Modal>
    );
  }

  return (
    <div className="PreCommissionStepperUnitCell">
      {removeDeviceModal}
      <div className="PreCommissionStepperUnitCellTitleRow">
        <div className="PreCommissionStepperUnitCellTitleRowHeader">
          {/* <IconAndText img={props.type === "donor" ? IconLoader.icon_donor : IconLoader.icon_service} text={props.type === "donor" ? "DONOR UNIT" : "SERVICE UNIT"}/> */}
          <img src={props.type === 'donor' ? IconLoader.icon_donor : IconLoader.icon_service} />
          <div className="PreCommissionStepperUnitCellTitleRowHeaderLabel">
            {props.type === 'donor' ? 'DONOR UNIT' : 'SERVICE UNIT'}
          </div>
        </div>
      </div>
      <div className="PreCommissionStepperUnitCellValueRow">
        {cellMode !== UNITCELL_MODES.TRANSITIONED && (
          <div className="PreCommissionStepperUnitCellValueRowControl">
            <input
              className={classnames('PreCommissionStepperUnitCellValueRowControlInput', {
                PreCommissionStepperUnitCellValueRowControlInputError: cellMode === UNITCELL_MODES.ERROR
              })}
              type="text"
              // defaultValue={props.deviceId ? props.deviceId : ""}
              value={
                inputValue == '' && props.deviceId && cellMode === UNITCELL_MODES.PRELOADED
                  ? props.deviceId
                  : inputValue
              }
              onChange={(evt) => {
                setInputValue(evt.target.value);
                if (cellMode === UNITCELL_MODES.ERROR || cellMode === UNITCELL_MODES.PRELOADED) {
                  setCellMode(UNITCELL_MODES.INITIALIZED);
                  if (props.isReady) props.sendValues({ isReady: false, deviceId: null });
                  if (props.isInvalid) props.sendValues({ isInvalid: false });
                }
              }}
            />
            {cellMode === UNITCELL_MODES.PRELOADED && props.deviceId != null && (
              <button
                className="PreCommissionStepperUnitCellValueRowControlDeleteButton"
                onClick={() => {
                  setRemoveDeviceModalOpen(true);
                }}
              >
                Remove
              </button>
            )}
            {inputValue != '' && cellMode === UNITCELL_MODES.INITIALIZED && (
              <div className="PreCommissionStepperUnitCellValueRowControlSubmit">
                <SvgAF
                  img={IconLoader.icon_field_enter}
                  hover={IconLoader.icon_field_enter_hover}
                  onClick={() => {
                    setCellMode(UNITCELL_MODES.PENDING);

                    getDevice(inputValue.trim())
                      .then((result) => {
                        if (result instanceof Error) {
                          result.message === '404'
                            ? setErrorMessage('The device does not exist')
                            : setErrorMessage('Unknown Error');
                          setCellMode(UNITCELL_MODES.ERROR);
                          props.sendValues && props.sendValues({ isInvalid: true });
                        } else if (result && result.deviceId) {
                          if (result.connectionState !== 'Connected') {
                            setErrorMessage('Device is Offline');
                            setCellMode(UNITCELL_MODES.ERROR);
                            props.sendValues && props.sendValues({ isInvalid: true });
                          } else if (
                            props.type === 'donor' &&
                            result.properties.reported.productType &&
                            distillProductType(result.properties.reported.productType) === 'donor'
                          ) {
                            setDeviceId(result.deviceId);
                            setSwVersion(getDeviceSwVersion(result));
                            setCellMode(UNITCELL_MODES.COMPLETED);
                            setErrorMessage(null);
                            props.sendValues &&
                              props.sendValues({
                                readOnly: true,
                                deviceId: result.deviceId,
                                swVersion: getDeviceSwVersion(result)
                              });
                          } else if (
                            props.type === 'service' &&
                            result.properties.reported.productType &&
                            distillProductType(result.properties.reported.productType) === 'service'
                          ) {
                            let readCells = props.readDeviceCells.map((dc) => ({ ...dc }));
                            if (readCells.find((d) => d.deviceId === result.deviceId)) {
                              props.sendValues && props.sendValues({ isInvalid: true });
                              setErrorMessage('Duplicate Device');
                              setCellMode(UNITCELL_MODES.ERROR);
                            } else {
                              setDeviceId(result.deviceId);
                              setSwVersion(getDeviceSwVersion(result));
                              setCellMode(UNITCELL_MODES.COMPLETED);
                              setErrorMessage(null);
                              props.sendValues &&
                                props.sendValues({
                                  readOnly: true,
                                  deviceId: result.deviceId,
                                  swVersion: getDeviceSwVersion(result)
                                });
                            }
                          } else {
                            setErrorMessage('Mismatched Product Type');
                            setCellMode(UNITCELL_MODES.ERROR);
                            props.sendValues && props.sendValues({ isInvalid: true });
                          }
                        } else {
                          setErrorMessage('Unknown Error');
                          setCellMode(UNITCELL_MODES.ERROR);
                          props.sendValues && props.sendValues({ isInvalid: true });
                        }
                      })
                      .catch((error) => console.error(error));
                  }}
                />
              </div>
            )}
            {cellMode === UNITCELL_MODES.PENDING && (
              <img
                className="PreCommissionStepperUnitCellValueRowControl_LoadingIcon Global_Spinner"
                src={IconLoader.icon_spinner_small}
                alt={'loading icon'}
              />
            )}
            {cellMode === UNITCELL_MODES.ERROR && (
              <img
                className="PreCommissionStepperUnitCellValueRowControl_ErrorIcon"
                src={IconLoader.icon_entered_failed}
                alt={'loading icon'}
              />
            )}
            {cellMode === UNITCELL_MODES.COMPLETED && (
              <img
                alt=""
                className="PreCommissionStepperUnitCellValueRowControlApproved defaultCheckmarkAnimation"
                src={IconLoader.icon_check_green}
              />
            )}
          </div>
        )}
        {cellMode === UNITCELL_MODES.ERROR && (
          <div className="PreCommissionStepperUnitCellValueRowErrorMessage">{errorMessage}</div>
        )}
        {cellMode === UNITCELL_MODES.TRANSITIONED && (
          <div className="PreCommissionStepperUnitCellValueRowPanel">
            <div className="PreCommissionStepperUnitCellValueRowPanelDeviceLabel">{deviceId}</div>
            <div className="PreCommissionStepperUnitCellValueRowPanelSwLabel" data-tip={swVersion}>
              {swVersion}
            </div>
          </div>
        )}
        {/* {
          cellMode === UNITCELL_MODES.DISABLED &&
          <div className="PreCommissionStepperUnitCellValueRowDisabledPanel">
            <div className="PreCommissionStepperUnitCellValueRowDisabledPanelDeviceLabel">
              {props.deviceId}
            </div>
            <div className="PreCommissionStepperUnitCellValueRowDisabledPanelStatusLabel">
              {"Removed"}
            </div>
          </div>
        } */}
      </div>
    </div>
  );
};

const PreCommissionStepperSiteCell = (props) => {
  const SITECELL_MODES = {
    PRELOADED: 'PRELOADED',
    INITIALIZED: 'INITIALIZED',
    ERROR: 'ERROR'
  };

  const [cellMode, setCellMode] = useState(SITECELL_MODES.INITIALIZED);
  const [inputValue, setInputValue] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (inputValue === '') {
      setInputValue(defaultValue);
      props.sendSite(defaultValue);
    } else if (inputValue.length > 50) {
      setErrorMessage('ID should be less than 50 characters');
      setCellMode(SITECELL_MODES.ERROR);
      props.sendInvalidSite(true);
    } else if (checkStringForHTML(inputValue)) {
      setErrorMessage('HTML detect in ID');
      setCellMode(SITECELL_MODES.ERROR);
      props.sendInvalidSite(true);
    } else {
      setErrorMessage('');
      setCellMode(SITECELL_MODES.INITIALIZED);
      props.sendInvalidSite(false);
    }
  }, [inputValue]);

  let defaultValue = '';

  if (props.device && props.device.id && props.localSiteId == null) defaultValue = 'site-' + props.device.id;
  else if (props.localSiteId != null) defaultValue = props.localSiteId;

  return (
    <div className="PreCommissionStepperSiteCell">
      <div className="PreCommissionStepperSiteCellTitleRow">
        <div className={'PreCommissionStepperSiteCellTitleRowHeader'}>SITE ID</div>
      </div>
      <div className="PreCommissionStepperSiteCellValueRow">
        {cellMode !== SITECELL_MODES.TRANSITIONED && cellMode !== SITECELL_MODES.DISABLED && (
          <div className="PreCommissionStepperSiteCellValueRowControl">
            <input
              className={classnames('PreCommissionStepperSiteCellValueRowControlInput', {
                PreCommissionStepperSiteCellValueRowControlInputError: cellMode === SITECELL_MODES.ERROR
              })}
              type="text"
              defaultValue={defaultValue}
              onChange={(evt) => {
                setInputValue(evt.target.value);
                props.sendSite(evt.target.value);
                if (cellMode === SITECELL_MODES.ERROR) setCellMode(SITECELL_MODES.INITIALIZED);
              }}
            />
          </div>
        )}
        {cellMode === SITECELL_MODES.ERROR && errorMessage != '' && (
          <div className="PreCommissionStepperSiteCellValueRowErrorMessage">{errorMessage}</div>
        )}
      </div>
    </div>
  );
};

const PreCommissionStepper = (props) => {
  const STEPPER_MODES = {
    UNITS: 'UNITS',
    SITE: 'SITE'
  };

  let dispatch = useDispatch();

  const [stepperMode, setStepperMode] = useState(STEPPER_MODES.UNITS);

  const [deviceCells, setDeviceCells] = useState(null);

  const [hasBundle, setHasBundle] = useState(false);
  const [localBundleId, setLocalBundleId] = useState(null);
  const [foundSiteId, setFoundSiteId] = useState(null);
  const [localSiteId, setLocalSiteId] = useState(null);
  const [localBundleType, setLocalBundleType] = useState(null);
  const [localBundleDescription, setLocalBundleDescription] = useState(null);
  const [isSwMismatchModalOpen, setSwMismatchModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const [isInvalidSite, setIsInvalidSite] = useState(false);

  const starterDeviceCells = [
    {
      deviceId: props.device,
      swVersion: null,
      type: 'donor',
      isReady: true,
      readOnly: true
    },
    {
      deviceId: null,
      swVersion: null,
      type: 'service',
      isReady: false
    },
    {
      deviceId: null,
      swVersion: null,
      type: 'service',
      isReady: false
    }
  ];

  useEffect(() => {
    if (
      hasBundle === false &&
      props.device &&
      props.device.properties &&
      props.device.properties.reported &&
      distillProductType(props.device.properties.reported.productType) === 'donor' &&
      props.device.tags &&
      props.device.tags.bundle &&
      props.device.tags.bundle.bundleId
    ) {
      dispatch(
        doGetBundle(props.device.tags.bundle.bundleId, (result) => {
          let serviceDevices = [];
          result.members.forEach((m) => {
            if (
              !(
                m.properties &&
                m.properties.reported &&
                m.properties.reported.productType &&
                distillProductType(m.properties.reported.productType) === 'donor'
              )
            ) {
              serviceDevices.push(m);
            }
          });

          let bundleDevices = [props.device].concat(serviceDevices);

          let createdDeviceCells = [];

          bundleDevices.forEach((bd, index) => {
            createdDeviceCells.push({
              type: distillProductType(bd.properties.reported.productType),
              deviceId: bundleDevices[index].deviceId,
              swVersion: getDeviceSwVersion(bundleDevices[index]),
              isReady: true,
              isPreloaded: true,
              readOnly: index == 0 ? true : false
            });
          });

          for (var i = 0; i < 3 - bundleDevices.length; i++) {
            createdDeviceCells.push({
              type: 'service',
              deviceId: null,
              swVersion: null,
              isReady: false,
              isPreloaded: false,
              readOnly: false
            });
          }

          setDeviceCells(createdDeviceCells);
          setLocalBundleId(props.device.tags.bundle.bundleId);
          setFoundSiteId(result.name);
          setLocalBundleType(result.type);
          setLocalBundleDescription(result.description);
          setHasBundle(true);
          setIsLoading(false);
        })
      );
    } else if (props.device && props.device.id && deviceCells == null) {
      let localDeviceCells = [...starterDeviceCells];
      localDeviceCells[0].deviceId = props.device.id;
      localDeviceCells[0].swVersion = getDeviceSwVersion(props.device);
      setDeviceCells(localDeviceCells);

      setIsLoading(false);
    }
  }, [props.device]);

  let swMismatchModal = null;
  let removeDeviceModal = null;

  if (isSwMismatchModalOpen) {
    swMismatchModal = (
      <Modal
        closeTargetRef={null}
        close={() => {
          setSwMismatchModalOpen(false);

          let unsetDeviceCells = [];

          deviceCells.forEach((dc) => {
            if (dc.type === 'donor')
              unsetDeviceCells.push({
                ...dc,
                readOnly: true
              });
            if (dc.type === 'service')
              unsetDeviceCells.push({
                ...dc,
                readOnly: false
              });
          });

          setDeviceCells(unsetDeviceCells);
        }}
        animate={false}
        animateX={false}
        opaque={true}
        height={490}
        width={480}
      >
        <div className="swMismatchModal">
          <div className="swMismatchModalTitle">Can't proceed to the next step</div>
          <div className="swMismatchModalDescription">All units need to have the same SW version</div>

          {deviceCells != null &&
            deviceCells.length > 0 &&
            deviceCells.map((c, index) => {
              if (c.deviceId)
                return (
                  <PreCommissionStepperUnitCell
                    key={index}
                    cellId={index}
                    deviceId={c.deviceId}
                    swVersion={c.swVersion}
                    isPreloaded={true}
                    type={c.type}
                    readOnly={true}
                  />
                );
            })}
          <div className="swMismatchModalFooter">
            <button
              className="swMismatchModalFooter_closeButton .Global_CancelButton"
              onClick={() => {
                setSwMismatchModalOpen(false);

                let unsetDeviceCells = [];

                deviceCells.forEach((dc) => {
                  if (dc.type === 'donor')
                    unsetDeviceCells.push({
                      ...dc,
                      readOnly: true
                    });
                  if (dc.type === 'service')
                    unsetDeviceCells.push({
                      ...dc,
                      readOnly: false
                    });
                });

                setDeviceCells(unsetDeviceCells);
              }}
            >
              Close
            </button>
          </div>
        </div>
      </Modal>
    );
  }

  return (
    <div className="PreCommissionStepper">
      {swMismatchModal}
      {removeDeviceModal}

      {isLoading === true && (
        <img
          className="PreCommissionStepperTopSpinner Global_Spinner"
          src={IconLoader.icon_spinner_small}
          alt={'loading icon'}
        />
      )}

      {isLoading === false && (
        <div>
          <div className="PreCommissionStepperHeader">
            <div className="PreCommissionStepperHeaderTitle">
              {stepperMode === STEPPER_MODES.UNITS && 'Connect donor unit with the service units'}
              {stepperMode === STEPPER_MODES.SITE && (
                <div className="PreCommissionStepperHeaderTitleSite">
                  <div>Provide the site ID (</div>
                  <div>Optional</div>
                  <div>)</div>
                </div>
              )}
            </div>
            {hasBundle == false && (
              <div className="PreCommissionStepperHeaderDesc">
                {stepperMode === STEPPER_MODES.UNITS &&
                  hasBundle == false &&
                  'Please provide one or two service unit ID numbers.'}
                {stepperMode === STEPPER_MODES.SITE && "You could leave it empty if you don't have it"}
              </div>
            )}
            {hasBundle == true && (
              <div className="PreCommissionStepperHeaderPivotDetail">
                {/* <IconAndText img={IconLoader.icon_pivot_large} text={"Pivot 5G site ID"}/> */}
                <div className="PreCommissionStepperHeaderPivotDetailIconLabel">
                  <img src={IconLoader.icon_pivot_large} />
                  <div className="PreCommissionStepperUnitCellTitleRowHeaderLabel">{'Pivot 5G site ID'}</div>
                </div>
                <div className="PreCommissionStepperHeaderPivotDetail_SiteLabel">{foundSiteId}</div>
              </div>
            )}
          </div>
          <div className="PreCommissionStepperContent">
            {/* <PreCommissionStepperUnitCell 
          cellId={0} 
          header={<IconAndText img={IconLoader.icon_donor} text={"DONOR UNIT"}/>} 
          doSetReadyCell= {(id) => {
            setReadyCells(readyCells[kvp.key] = kvp.value)}
          }
        />
        <PreCommissionStepperUnitCell 
          cellId={1} 
          header={<IconAndText img={IconLoader.icon_service} text={"SERVICE UNIT"}/>}
          doSetReadyCell= {(kvp) => setReadyCells(readyCells[kvp.key] = kvp.value)}
        />
        <PreCommissionStepperUnitCell 
          cellId={2} 
          header={<IconAndText img={IconLoader.icon_service} text={"SERVICE UNIT"} />}
          doSetReadyCell= {(kvp) => setReadyCells(readyCells[kvp.key] = kvp.value)}
        /> */}
            {stepperMode === STEPPER_MODES.UNITS && (
              <div className="PreCommissionStepperContentUnits">
                {deviceCells != null &&
                  deviceCells.length > 0 &&
                  deviceCells.map((c, index) => {
                    return (
                      <PreCommissionStepperUnitCell
                        key={index}
                        cellId={index}
                        deviceId={c.deviceId}
                        swVersion={c.swVersion}
                        type={c.type}
                        isPreloaded={c.isPreloaded}
                        isInvalid={c.isInvalid}
                        readDeviceCells={deviceCells.map((dc) => ({ ...dc }))}
                        isReady={c.isReady}
                        sendValues={(values) => {
                          let newCells = [...deviceCells];

                          if (values.isReady === true || values.isReady === false)
                            newCells[index].isReady = values.isReady;
                          if (values.deviceId !== undefined) {
                            newCells[index].deviceId = values.deviceId;
                          }
                          if (values.swVersion) newCells[index].swVersion = values.swVersion;
                          if (values.readOnly) newCells[index].readOnly = values.readOnly;
                          if (values.isInvalid === true || values.isInvalid === false)
                            newCells[index].isInvalid = values.isInvalid;

                          if (values.doReset) newCells[index] = { ...starterDeviceCells[1] };

                          setDeviceCells(newCells);
                        }}
                        readOnly={c.readOnly}
                      />
                    );
                  })}
              </div>
            )}
            {stepperMode === STEPPER_MODES.SITE && (
              <div className="PreCommissionStepperContentSite">
                <PreCommissionStepperSiteCell
                  device={props.device}
                  localSiteId={foundSiteId}
                  sendSite={(siteId) => {
                    setLocalSiteId(siteId);
                  }}
                  sendInvalidSite={(isInvalid) => {
                    setIsInvalidSite(isInvalid);
                  }}
                />
              </div>
            )}
          </div>

          <div className="PreCommissionStepperContentFooter">
            <button
              className="PreCommissionStepperContentFooterContinueButton"
              disabled={
                deviceCells.filter((dc) => dc.isReady === false).length >= 2 ||
                deviceCells.find((dc) => dc.isInvalid === true) ||
                isInvalidSite === true
              }
              onClick={() => {
                let filteredDeviceCells = [...deviceCells].filter(
                  (dc) => dc.isInvalid == null || dc.isInvalid === false
                );

                if (
                  filteredDeviceCells.every(
                    (dc) => dc.deviceId == null || dc.swVersion === filteredDeviceCells[0].swVersion
                  ) === false
                ) {
                  setSwMismatchModalOpen(true);
                } else if (stepperMode === STEPPER_MODES.UNITS) setStepperMode(STEPPER_MODES.SITE);
                else if (stepperMode === STEPPER_MODES.SITE) {
                  let filteredDevices = deviceCells
                    .filter((dc) => (dc.isInvalid == null || dc.isInvalid === false) && dc.deviceId != null)
                    .map((dc) => dc.deviceId);
                  let suUnits = filteredDevices.slice(1);
                  hasBundle
                    ? dispatch(
                        doPatchBundle(
                          props.device.tags.bundle.bundleId,
                          { name: localSiteId, type: 'Pivot 5G', members: filteredDevices, description: null },
                          () => {
                            props.sendPreCommissioningCompleteDevices(suUnits);
                            props.sendPreCommissioningCompleteSite(localSiteId);
                          }
                        )
                      )
                    : 
                    
                    dispatch(
                        doCreateBundle({"name":localSiteId, "type":'Pivot 5G', "members":filteredDevices}, null, () => {
                          props.sendPreCommissioningCompleteDevices(suUnits);
                          props.sendPreCommissioningCompleteSite(localSiteId);
                        })
                      );
                }
              }}
            >
              Continue
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default memo(PreCommissionStepper);
